<template>
  <div class="d-flex flex-column page-wrapper challenge-questions">
    <page-header>
      <span v-if="isJointApplication == false">{{ $t("message.challengeQuestions") }}</span>
      <span v-if="isJointApplication == true && isPrimary">{{ $t("message.primaryApplicantChallengeQuestions" )}}</span>
      <span v-if="isJointApplication == true && !isPrimary">{{ $t("message.jointApplicantChallengeQuestions" )}}</span>
    </page-header>
    <div class="container d-flex flex-column align-items-center page-container">
      <div class="d-flex flex-row justify-content-around steps-container">
        <div class="dot previous-dot"></div><!-- Identification -->
        <div class="dot previous-dot"></div><!-- Contact Info -->
        <div class="dot current-dot"></div><!-- Other Info -->
        <div class="dot next-dot" v-if="isJointApplication == true"/><!-- Joint Identification -->
        <div class="dot next-dot" v-if="isJointApplication == true"/><!-- Joint Contact Info -->
        <div class="dot next-dot" v-if="isJointApplication == true"/><!-- Joint Other Info -->
        <div class="dot next-dot"></div><!-- Accounts -->
        <div class="dot next-dot"></div><!-- Funding -->
        <div class="dot next-dot"></div><!-- Review -->
      </div>
      <p class="explanation-text">
        Thanks for all that information, we know it's a lot to go through. 
        A big part of our commitment to our members is protecting their identity. 
        Based on the information you entered, we have some quick questions we'd like you to verify for the primary applicant.
      </p>
      <div class="d-flex flex-column justify-content-start align-items-start form-container" v-if="!loadingQuestions && !answeringQuestions">
        <b-form @submit.prevent="submit" novalidate>
          <b-form-group class="form-label" :label="question.questionText" v-for="question in challengeQuestions" :key="question.id">
            <b-button-group vertical class="btn-width" :id="$id('question'+question.id)">
              <b-button class="btn" variant="outline-primary" :pressed="answer.selected === true" @click="selectQuestionAnswer(question, answer)" v-for="answer in question.options" :key="answer.id">
                {{ answer.text }}
              </b-button>   
            </b-button-group>
          </b-form-group>
          <div class="d-flex flex-column justify-content-between align-items-center final-action-div">
            <b-button variant="secondary" type="submit" :id="$id('next')" class="btn btn-width">
              <span>{{ $t("message.next" )}}</span>
            </b-button>
            <b-button variant="light" @click="back()" :id="$id('back')" class="btn btn-width">
              <span v-if="!editMode">{{ $t("message.back" )}}</span>
              <span v-if="editMode">{{ $t("message.cancel" )}}</span>
            </b-button>
          </div>
        </b-form>
      </div>
      <div class="d-flex flex-column align-items-center align-content-center justify-content-center form-container" v-if="loadingQuestions">
        <p class="processing-text">Generating your verification questions. Please do not refresh or close this page.</p>
        <img src="@/assets/img/light/activity.gif" class="processing-img" />                           
      </div>
      <div class="d-flex flex-column align-items-center align-content-center justify-content-center form-container" v-if="answeringQuestions">
        <p class="processing-text">Verifying your answers. Please do not refresh or close this page.</p>
        <img src="@/assets/img/light/activity.gif" class="processing-img" />                           
      </div>
    </div>
    <page-footer />
    <b-modal ref="errorModalRef" body-text-variant="dark" header-text-variant="dark" centered ok-only ok-variant="secondary" title="Missing Information">You must respond to all questions.</b-modal>
    <b-modal ref="failedQuestionsModalRef" body-text-variant="dark" header-text-variant="dark" centered ok-only ok-variant="secondary" title="Incorrect Information">Your answers were not correct, please try again.</b-modal>
    <b-modal ref="questionLoadModalRef" body-text-variant="dark" header-text-variant="dark" centered title="Verification Issue" no-close-on-backdrop no-close-on-esc>
      <p>We're sorry, we are unable to process your request at this time. Please try again later.</p>
      <div slot="modal-footer">
        <b-button variant="secondary" @click="endApplication">OK</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "ChallengeQuestions",
  components: {
  },
  directives: {
    mask
  },
  props: {
    isPrimary: { type: Boolean, required: true }
  },
  created() {
    this.getQuestions();
  },
  mounted() {
  },
  data() {
    return {
      pageContent: [],
      challengeQuestions: [], 
      quizId: '',
      tranId: '',           
      loadingQuestions: false,      
      answeringQuestions: false,
      questionRetryCount: 0,
    };
  },
  computed: {
    ...mapState([
      'currentState',
      'editMode',
      'creditUnion',
      'isJointApplication',
      'primaryApplicant',
      'jointApplicant',
      'editedIdentificationInfo',
      'editedContactInfo',
      'challengeQuestionsRequired',
      'challengeQuestionsRetryAttempts'
    ]),
    ...mapGetters([
        'getPageContent',
        'primaryReferenceRequired',
        'jointReferenceRequired',
    ]),
    creditUnionName: {
      get() {
        return this.creditUnion.name;
      }
    },
    challengedQuestionsAnswered: {
      get() {
        if(this.isPrimary) {
          return this.primaryApplicant.challengedQuestionsAnswered;
        } else {
          return this.jointApplicant.challengedQuestionsAnswered;
        }
      },
      set(value) {
        this.updateChallengeQuestionsAnswered({ isPrimary: this.isPrimary, challengedQuestionsAnswered: value });
      }
    },
  },
  methods: {    
    ...mapMutations([
      'updateChallengeQuestionsAnswered',
      'updateProgress',
      'updateEditedIdentificationInfo'
    ]),
    ...mapActions([        
      'getChallengeQuestions',
      'answerChallengeQuestions',
      'resetState'
    ]),
    back() {
      if(this.isPrimary) {
        this.$router.push('otherinformation');
      } else {
        this.$router.push('jointotherinformation');
      }
    },
    getQuestions: async function() {
      this.loadingQuestions = true;
      
      this.getChallengeQuestions({ isPrimary: this.isPrimary }).then(async (response) => {
        if(response) {
          this.challengeQuestions = response.challengeQuestions;        
          this.tranId = response.transactionId;
          this.quizId = response.id;
        } else {          
          if(this.challengeQuestionsRequired) {
            this.$refs.questionLoadModalRef.show();
          } else {
            this.challengedQuestionsAnswered = true;
            this.updateProgress();
            
            if(this.editedIdentificationInfo || this.editedContactInfo) {
                this.$router.push('review');
            } else if(this.primaryReferenceRequired && this.isPrimary  === true) {
              this.$router.push("references");
            } else if(this.jointReferenceRequired && this.isPrimary === false) {
              this.$router.push("jointreferences");
            } else if(this.isJointApplication && this.isPrimary === true) {
                this.$router.push('jointidentification');
            } else {
                this.$router.push("review");
            }
          }
        }
        this.loadingQuestions = false;
      });
    },
    selectQuestionAnswer: function(question, answer) {
      for(let i = 0; i < question.options.length; i++) {
        if(question.options[i].id === answer.id) {          
          this.$set(question.options[i], "selected", true);
        } else {
          this.$set(question.options[i], "selected", false);
        }        
      }        
      question.response = answer.id;
    },      
    submit: async function() {
      let error = false;
      for(var i = 0; i < this.challengeQuestions.length; i++) {
        if(!this.challengeQuestions[i].response) {
          error = true;
        }
      }
      
      if(error) {
        this.$refs.errorModalRef.show();
      } else {
        this.answeringQuestions = true;
        let success = await this.answerChallengeQuestions({ isPrimary: this.isPrimary, questions: this.challengeQuestions, quizId: this.quizId, tranId: this.tranId });
        if(success) {
            this.challengedQuestionsAnswered = true;
            this.updateProgress();
            
            if(this.editedIdentificationInfo || this.editedContactInfo) {
                this.$router.push('review');
            } else if(this.primaryReferenceRequired && this.isPrimary  === true) {
              this.$router.push("references");
            } else if(this.jointReferenceRequired && this.isPrimary === false) {
              this.$router.push("jointreferences");
            } else if(this.isJointApplication && this.isPrimary === true) {
                this.$router.push('jointidentification');
            } else {
                this.$router.push("review");
            }
        } else {
          this.questionRetryCount++;
          if(this.questionRetryCount > this.challengeQuestionsRetryAttempts) {
            if(this.challengeQuestionsRequired) {
              this.$refs.failedQuestionsModalRef.show();
            } else {
              if(this.editedIdentificationInfo || this.editedContactInfo) {
                this.$router.push('review');
              } else if(this.primaryReferenceRequired && this.isPrimary  === true) {
                this.$router.push("references");
              } else if(this.jointReferenceRequired && this.isPrimary === false) {
                this.$router.push("jointreferences");
              } else if(this.isJointApplication && this.isPrimary === true) {
                  this.$router.push('jointidentification');
              } else {
                  this.$router.push("review");
              }
            }
          } else {            
            await this.getQuestions(); 
          }          
        }
        this.answeringQuestions = false;
      }
    },
    endApplication() {
        this.resetState();
        this.$router.push("/");
        //window.location.replace("https://www.creditUnionUrl.org/")
    }
  },
};
</script>